import axios from 'axios';

export default {
  processReconciliationPrice(inventoryId, items) {
    return axios.post(`${process.env.VUE_APP_PORTAUS_API_URL}:${process.env.VUE_APP_PORTAUS_API_PORT}/API/latest/admin/inventories/${inventoryId}/reconciliation-files/prices/process`, items)
      .then(response => {
        return response.data;
      });
  },
  fetchProductPuidItemsPerformance(puid, inventoryId, params) {
    return axios.get(`${process.env.VUE_APP_PORTAUS_API_URL}:${process.env.VUE_APP_PORTAUS_API_PORT}/API/v1/admin/inventories/${inventoryId}/products/${puid}/items/performance`, { params })
    .then(response=>{
      return response.data;
    })
  },
  fetchProductsPerformanceSummary(inventoryId, params) {
    return axios.get(`${process.env.VUE_APP_PORTAUS_API_URL}:${process.env.VUE_APP_PORTAUS_API_PORT}/API/v1/admin/inventories/${inventoryId}/products/performance-summary`, { params })
      .then(response => {
        return response.data;
      });
  },
  fetchPurchaseOrdersForecast(inventoryId, params) {
    return axios.get(`${process.env.VUE_APP_PORTAUS_API_URL}:${process.env.VUE_APP_PORTAUS_API_PORT}/API/v1/admin/inventories/${inventoryId}/products/purchase-orders-forecast`, { params })
      .then(response => {
        return response.data;
      });
  },
  fetchInventoryProductsValorization(params) {
    return axios.get(`${process.env.VUE_APP_PORTAUS_API_URL}:${process.env.VUE_APP_PORTAUS_API_PORT}/API/v1/admin/inventories/products/inventory-products-valorization`, { params })
      .then(response => {
        return response.data;
      });
  },
  fetchPrivateImportLotsIpReport(params) {
    return axios.get(`${process.env.VUE_APP_PORTAUS_API_URL}:${process.env.VUE_APP_PORTAUS_API_PORT}/API/v1/admin/inventories/products/private-import-lots-ip-report`, { params })
      .then(response => {
        return response.data;
      });
  },
  publishPuid (puid, publishInfos) {
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/inventories/products/" + puid + "/publish", publishInfos)
      .then(response=>{
        return response.data;
      })
  },
  generatePuid (inventoryId, productId) {
    const params = {
      inventoryId,
      productId
    }
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/inventories/puid", {params : params})
      .then(response=>{
        return response.data;
      })
  },
  getInventories(params){
			return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventories", { params })
        .then(response=>{
          return response.data;
        })
  },
  getInventoriesV2(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/inventories", { params })
      .then(response=>{
        return response.data;
      })
},
  getInventory(inventoryId){
			return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventories/"+inventoryId)
        .then(response=>{
          return response.data;
        })
  },
  createInventory(inventory){
			return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventories", inventory)
        .then(response=>{
          return response.data;
        })
  },
  updateInventory(inventory){
			return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventories/"+inventory.id, inventory)
        .then(response=>{
          return response.data;
        })
  },
  deleteInventory(inventoryId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventories/"+inventoryId)
      .then(response=>{
        return response.data;
      })
  },
  //DEPRECATED USE PRODUCT API INSTEAD (LISTPRODUCT)
  listItems(params){

    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items/", {params : params})
      .then(response=>{
        return response.data;
      })
  },
  createItem(item){//DEPRECATED
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items", item)
      .then(response=>{
        return response.data;
      })
  },
  updateInventoryItem(inventoryId, item){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventories/"+inventoryId+"/items/"+item.id, item)
      .then(response=>{
        return response.data;
      })
  },
  deleteItem(itemId){//DEPRECATED
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items/"+itemId)
      .then(response=>{
        return response.data;
      })
  },
  // DEPRECATED use getProductPriceV2 instead
  getProductPrice(inventoryId, productId, params){
    params.inventoryId =  inventoryId;
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/products/"+productId+"/price", {params : params})
      .then(response=>{
        return response.data;
      })
  },
  getProductPriceV2(inventoryId, productId, params){
    params.inventoryId =  inventoryId;
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/products/"+productId+"/price", {params : params})
      .then(response=>{
        return response.data;
      })
  },
  // DEPRECATED. USE fetchProductsV2 Instead
  fetchProducts(params,inventoryId=null){
    let endpoint = "/API/inventories/";
    if(inventoryId)endpoint+=inventoryId+"/";
    endpoint +="products";
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+endpoint, {params})
      .then(response=>{
        return response.data;
      })
  },
  fetchProductsV2 (params, inventoryId=null, axiosConfig={}) {
    let endpoint = "/API/latest/admin/inventories/";
    if(inventoryId)endpoint+=inventoryId+"/";
    endpoint +="products";
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+endpoint, { params, ...axiosConfig })
      .then(response=>{
        return response.data;
      })
  },
  // fetchProducts(inventoryId, params){//DEPRECATED
  //   return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventories/"+inventoryId+"/products", {params : params})
  //     .then(response=>{
  //       return response.data;
  //     })
  // },
  getInventoryItem(inventoryId, itemId){//DEPRECATED
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventories/"+inventoryId+"/items/"+itemId)
      .then(response=>{
        return response.data;
      })
  },
  getInventoryProductV2(puid){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/inventories/products/"+ puid)
      .then(response=>{
        return response.data;
      })
  },
  //DEPRECATED USE getInventoryProductV2 instead
  getInventoryProduct(inventoryId, productID){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventories/"+inventoryId+"/products/"+productID)
      .then(response=>{
        return response.data;
      })
  },
  getStats(){//DEPRECATED
    let params ={summary:true};
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items/", {params : params})
      .then(response=>{
        return response.data;
      })
  },
  getInventoryStats(inventoryId){
    let params ={summary:true};
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventories/"+inventoryId, {params : params})
      .then(response=>{
        return response.data;
      })
  },
  downloadInventoryReport(params, filename){
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/inventories/${params.inventoryId}/products/report`;
    params.active = true;
    params.paging = false;
    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           link.setAttribute('download', filename); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  }

}
